import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

const TradeChartScreen = () => {
  const { curid, cur_code } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  
  const [volume, setVolume] = useState('');
  const [mrg, setMrg] = useState(0);
  const [lev, setLev] = useState(0);
  const [tradeType, setTradeType] = useState('');
  const [uid, setUid] = useState();
  const [rate, setRate] = useState();
  const [loading, setLoading] = useState(true);
  const [high, setHigh] = useState();
  const [open, setOpen] = useState();
  const [low, setLow] = useState();
  const [target, setTarget] = useState('');
  const [stoploss, setStoploss] = useState('');
  const [limit, setLimit] = useState('');
  const [balance, setBalance] = useState();
  const [name, setName] = useState();
  const [buyPrice, setBuyPrice] = useState();
  const [sellPrice, setSellPrice] = useState();
  const [buyColor, setBuyColor] = useState('');
  const [sellColor, setSellColor] = useState('');
  const [orderType, setOrderType] = useState('Market');
  const [tradePrice, setTradePrice] = useState('');
  const [spinner, setSpinner] = useState(false);
  const [showBalance, setShowBalance] = useState(true);

  // Fetch user data and wallet balance
  useEffect(() => {
    const fetchData = async () => {
      try {
        const uid = localStorage.getItem("userid");
        const name = localStorage.getItem("name");
        setName(name);
        setUid(uid);

        const response = await fetch('https://singlewindowsecurities.com/Rest3/home_wallet_api/' + uid);
        const responseJson = await response.json();
        setBalance(responseJson.bal);
        setLev(responseJson.lev || 0);
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, []);

  // Fetch real-time data
  useEffect(() => {
    const interval = setInterval(() => {
      fetch('https://aurofxmarket.in/Rest/curr_live_rate_api/' + curid)
        .then((response) => response.json())
        .then((responseJson) => {
          setRate(responseJson.cbuy_price);
          setBuyPrice(responseJson.cbuy_price);
          setSellPrice(responseJson.csell_price);
          setBuyColor(responseJson.buy_color);
          setSellColor(responseJson.sell_color);
          setHigh(responseJson.curr_high);
          setLow(responseJson.curr_low);
          setMrg(responseJson.mrg_val);
          setLoading(false);
        }).catch((error) => {
          console.log(error);
        });
    }, 2000);

    return () => clearInterval(interval);
  }, [curid]);

  const placeOrder = async () => {
    var need = sellPrice * volume;
    if (orderType === 'Pending' && tradePrice === '') {
      alert("Please Set Order Start Price.");
      return false;
    }
    if (volume <= 0 || !volume) {
      alert("Please Enter Correct Lot Size");
      return false;
    }
    
    setSpinner(true);
    const uid = localStorage.getItem("userid");
    let cused;
    if (orderType === 'SELL') {
      cused = (buyPrice * volume * mrg * 1 / lev).toFixed(2);
    } else {
      cused = (sellPrice * volume * mrg * 1 / lev).toFixed(2);
    }
    const formData = new FormData();
    formData.append('pending_val', tradePrice);
    formData.append('trade_type', tradeType);
    formData.append('buy_price', buyPrice);
    formData.append('sell_price', sellPrice);
    formData.append('user', uid);
    formData.append('need', need);
    formData.append('cur_code', cur_code);
    formData.append('lotsize', volume);
    formData.append('target', target);
    formData.append('cused', cused);
    formData.append('stoploss', stoploss);
    formData.append('order_type', orderType);

    fetch('https://singlewindowsecurities.com/Rest3/web_trade_submit_api2/', {
      method: 'POST',
      body: formData,
    })
    .then((response) => response.json())
    .then((responseJson) => {
      console.log(responseJson);
      setSpinner(false);
      alert(responseJson.msg);
      if (responseJson.status == 0) {
        navigate('/forex');
      }
    })
    .catch((error) => {
      setSpinner(false);
      console.log('Error:', error);
    });
  };

  const incVolLot = (type) => {
    let num = parseFloat(volume) || 0;
    if (type === "plus") {
      num += 0.1;
    } else if (type === "minus" && num > 0) {
      num -= 0.1;
    }
    setVolume(num.toFixed(2).toString());
  };

  const formatNumber = (num) => {
    if (!num && num !== 0) return '0';
    const numValue = parseFloat(num);
    if (isNaN(numValue)) return '0';
    return numValue.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 4
    });
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh', background: '#0a0a0a' }}>
        <div className="text-center">
          <div className="spinner-border" style={{ color: '#D4AF37' }} role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-3" style={{ color: '#D4AF37' }}>Loading Trading Data...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid p-0" style={{ 
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 50%, #0d0d0d 100%)'
    }}>
      {/* Loading Spinner Overlay */}
      {spinner && (
        <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" 
             style={{ background: 'rgba(0, 0, 0, 0.8)', zIndex: 9999 }}>
          <div className="text-center">
            <div className="spinner-border" style={{ color: '#D4AF37' }} role="status">
              <span className="visually-hidden">Processing...</span>
            </div>
            <p className="mt-2" style={{ color: '#D4AF37' }}>Processing Order...</p>
          </div>
        </div>
      )}

      {/* Header Section */}
      <div style={{
        background: 'rgba(10, 10, 10, 0.95)',
        backdropFilter: 'blur(10px)',
        borderBottom: '1px solid rgba(212, 175, 55, 0.3)',
        position: 'sticky',
        top: 0,
        zIndex: 100
      }}>
        <div className="container py-3">
          <div className="d-flex align-items-center">
            <button 
              onClick={() => navigate(-1)}
              className="btn"
              style={{
                background: 'rgba(212, 175, 55, 0.1)',
                border: '1px solid rgba(212, 175, 55, 0.3)',
                borderRadius: '12px',
                width: '36px',
                height: '36px',
                color: '#D4AF37',
                marginRight: '12px'
              }}
            >
              <i className="fa fa-arrow-left"></i>
            </button>
            
            <div className="flex-grow-1">
              <h5 className="fw-bold mb-0" style={{ color: '#D4AF37' }}>{cur_code?.toUpperCase()}</h5>
              <small style={{ color: '#888' }}>Pair ID: #{curid}</small>
            </div>
          </div>
        </div>
      </div>

      <div className="container mt-3">
        {/* Price Card */}
        <div style={{
          background: 'linear-gradient(145deg, rgba(212, 175, 55, 0.15), rgba(184, 150, 12, 0.05))',
          borderRadius: '24px',
          padding: '20px',
          border: '1px solid rgba(212, 175, 55, 0.2)',
          marginBottom: '16px'
        }}>
          <div className="text-center">
            <small style={{ color: '#D4AF37', letterSpacing: '1px', fontSize: '11px' }}>CURRENT RATE</small>
            <h2 className="fw-bold mb-2" style={{ color: '#D4AF37' }}>${formatNumber(rate)}</h2>
            <div className="row g-3 mt-2">
              <div className="col-6">
                <div style={{
                  background: 'rgba(255, 82, 82, 0.1)',
                  borderRadius: '16px',
                  padding: '12px'
                }}>
                  <small style={{ color: '#888' }}>BID PRICE</small>
                  <div style={{ color: '#FF5252', fontWeight: 'bold', fontSize: '18px' }}>${formatNumber(sellPrice)}</div>
                </div>
              </div>
              <div className="col-6">
                <div style={{
                  background: 'rgba(0, 200, 83, 0.1)',
                  borderRadius: '16px',
                  padding: '12px'
                }}>
                  <small style={{ color: '#888' }}>ASK PRICE</small>
                  <div style={{ color: '#00C853', fontWeight: 'bold', fontSize: '18px' }}>${formatNumber(buyPrice)}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Chart Section */}
        <div style={{
          background: 'rgba(20, 20, 20, 0.95)',
          borderRadius: '24px',
          border: '1px solid rgba(212, 175, 55, 0.2)',
          overflow: 'hidden',
          marginBottom: '16px'
        }}>
          <div className="p-3">
            <h6 className="fw-bold mb-2" style={{ color: '#D4AF37', letterSpacing: '1px' }}>LIVE CHART</h6>
            <iframe 
              src={`https://aurofxmarket.in/Rest/forex_chart/${cur_code?.replace("-", "")}`}
              style={{ width: '100%', height: '350px', border: 'none', borderRadius: '16px' }}
              title="Forex Chart"
            />
          </div>
        </div>

        {/* Quick Stats */}
        <div className="row g-3 mb-4">
          <div className="col-4">
            <div style={{
              background: 'rgba(26, 26, 26, 0.8)',
              borderRadius: '16px',
              padding: '12px',
              textAlign: 'center',
              border: '1px solid rgba(212, 175, 55, 0.1)'
            }}>
              <small style={{ color: '#888', fontSize: '10px' }}>HIGH</small>
              <div style={{ color: '#FF5252', fontWeight: 'bold' }}>${formatNumber(high)}</div>
            </div>
          </div>
          <div className="col-4">
            <div style={{
              background: 'rgba(26, 26, 26, 0.8)',
              borderRadius: '16px',
              padding: '12px',
              textAlign: 'center',
              border: '1px solid rgba(212, 175, 55, 0.1)'
            }}>
              <small style={{ color: '#888', fontSize: '10px' }}>LOW</small>
              <div style={{ color: '#00C853', fontWeight: 'bold' }}>${formatNumber(low)}</div>
            </div>
          </div>
          <div className="col-4">
            <div style={{
              background: 'rgba(26, 26, 26, 0.8)',
              borderRadius: '16px',
              padding: '12px',
              textAlign: 'center',
              border: '1px solid rgba(212, 175, 55, 0.1)'
            }}>
              <small style={{ color: '#888', fontSize: '10px' }}>LEVERAGE</small>
              <div style={{ color: '#D4AF37', fontWeight: 'bold' }}>1:{lev}</div>
            </div>
          </div>
        </div>

        {/* New Order Section */}
        {!tradeType ? (
          <div className="row g-3 mb-4">
            <div className="col-6">
              <button
                className="btn w-100 py-4 d-flex flex-column align-items-center"
                onClick={() => setTradeType('SELL')}
                style={{
                  background: 'rgba(255, 82, 82, 0.1)',
                  border: '2px solid rgba(255, 82, 82, 0.3)',
                  borderRadius: '20px',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'rgba(255, 82, 82, 0.2)';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'rgba(255, 82, 82, 0.1)';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <i className="fa fa-arrow-down" style={{ color: '#FF5252', fontSize: '28px' }}></i>
                <span className="fw-bold mt-2" style={{ color: '#FF5252' }}>SELL</span>
                <small style={{ color: '#888' }}>${formatNumber(sellPrice)}</small>
              </button>
            </div>
            <div className="col-6">
              <button
                className="btn w-100 py-4 d-flex flex-column align-items-center"
                onClick={() => setTradeType('BUY')}
                style={{
                  background: 'rgba(0, 200, 83, 0.1)',
                  border: '2px solid rgba(0, 200, 83, 0.3)',
                  borderRadius: '20px',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'rgba(0, 200, 83, 0.2)';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'rgba(0, 200, 83, 0.1)';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <i className="fa fa-arrow-up" style={{ color: '#00C853', fontSize: '28px' }}></i>
                <span className="fw-bold mt-2" style={{ color: '#00C853' }}>BUY</span>
                <small style={{ color: '#888' }}>${formatNumber(buyPrice)}</small>
              </button>
            </div>
          </div>
        ) : (
          <div style={{
            background: 'rgba(20, 20, 20, 0.95)',
            borderRadius: '24px',
            border: '1px solid rgba(212, 175, 55, 0.2)',
            marginBottom: '16px'
          }}>
            <div className="p-4">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <span style={{
                  background: tradeType === 'BUY' ? 'rgba(0, 200, 83, 0.15)' : 'rgba(255, 82, 82, 0.15)',
                  color: tradeType === 'BUY' ? '#00C853' : '#FF5252',
                  padding: '6px 16px',
                  borderRadius: '30px',
                  fontWeight: 'bold'
                }}>
                  {tradeType} {cur_code?.toUpperCase()}
                </span>
                <button 
                  className="btn"
                  onClick={() => setTradeType('')}
                  style={{
                    background: 'rgba(212, 175, 55, 0.1)',
                    borderRadius: '10px',
                    width: '32px',
                    height: '32px',
                    color: '#D4AF37'
                  }}
                >
                  <i className="fa fa-x"></i>
                </button>
              </div>

              {/* Lot Size Selection */}
              <div className="mb-4">
                <label className="form-label small" style={{ color: '#D4AF37', letterSpacing: '1px' }}>LOT SIZE</label>
                <div className="d-flex align-items-center justify-content-between">
                  <button 
                    onClick={() => incVolLot('minus')}
                    className="btn"
                    style={{
                      background: 'rgba(212, 175, 55, 0.1)',
                      borderRadius: '12px',
                      width: '44px',
                      height: '44px',
                      color: '#D4AF37'
                    }}
                  >
                    <i className="fa fa-dash-lg"></i>
                  </button>
                  
                  <input
                    type="number"
                    className="form-control text-center fw-bold"
                    style={{
                      width: '100px',
                      height: '44px',
                      background: '#1a1a1a',
                      border: '1px solid rgba(212, 175, 55, 0.3)',
                      borderRadius: '12px',
                      color: '#D4AF37',
                      fontSize: '18px'
                    }}
                    value={volume}
                    onChange={(e) => setVolume(e.target.value)}
                  />
                  
                  <button 
                    onClick={() => incVolLot('plus')}
                    className="btn"
                    style={{
                      background: 'rgba(212, 175, 55, 0.1)',
                      borderRadius: '12px',
                      width: '44px',
                      height: '44px',
                      color: '#D4AF37'
                    }}
                  >
                    <i className="fa fa-plus-lg"></i>
                  </button>
                </div>
              </div>

              {/* Margin Required */}
              <div className="mb-4 p-3" style={{
                background: 'rgba(212, 175, 55, 0.05)',
                borderRadius: '16px',
                border: '1px solid rgba(212, 175, 55, 0.1)'
              }}>
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <small style={{ color: '#888' }}>Margin Required</small>
                    <div className="fw-bold" style={{ color: '#D4AF37' }}>
                      ${formatNumber(volume && (tradeType === 'BUY' ? sellPrice * volume * mrg * 1 / lev : buyPrice * volume * mrg * 1 / lev))}
                    </div>
                  </div>
                  <div className="text-end">
                    <small style={{ color: '#888' }}>Available Balance</small>
                    <div className="fw-bold" style={{ color: '#fff' }}>
                      ${formatNumber(balance)}
                    </div>
                  </div>
                </div>
              </div>

              {/* Order Type */}
              <div className="mb-4">
                <label className="form-label small" style={{ color: '#D4AF37', letterSpacing: '1px' }}>ORDER TYPE</label>
                <div className="d-flex gap-2">
                  <button
                    onClick={() => setOrderType('Market')}
                    className={`btn flex-fill py-2 ${orderType === 'Market' ? 'btn-golden' : ''}`}
                    style={{
                      background: orderType === 'Market' ? 'linear-gradient(145deg, #D4AF37, #B8960C)' : 'rgba(26, 26, 26, 0.8)',
                      border: orderType === 'Market' ? 'none' : '1px solid rgba(212, 175, 55, 0.3)',
                      borderRadius: '12px',
                      color: orderType === 'Market' ? '#000' : '#fff',
                      fontWeight: 'bold'
                    }}
                  >
                    Market
                  </button>
                </div>
              </div>

              {/* Target & Stop Loss */}
              <div className="row g-3 mb-4">
                <div className="col-6">
                  <label className="form-label small" style={{ color: '#D4AF37' }}>TARGET PRICE</label>
                  <input
                    type="number"
                    className="form-control"
                    style={{
                      background: '#1a1a1a',
                      border: '1px solid rgba(212, 175, 55, 0.3)',
                      borderRadius: '12px',
                      color: '#fff'
                    }}
                    placeholder="Set target"
                    value={target}
                    onChange={(e) => setTarget(e.target.value)}
                    step="0.01"
                  />
                </div>
                <div className="col-6">
                  <label className="form-label small" style={{ color: '#D4AF37' }}>STOP LOSS</label>
                  <input
                    type="number"
                    className="form-control"
                    style={{
                      background: '#1a1a1a',
                      border: '1px solid rgba(212, 175, 55, 0.3)',
                      borderRadius: '12px',
                      color: '#fff'
                    }}
                    placeholder="Set stop loss"
                    value={stoploss}
                    onChange={(e) => setStoploss(e.target.value)}
                    step="0.01"
                  />
                </div>
              </div>

              {/* Action Buttons */}
              <div className="d-flex gap-3">
                <button
                  className="btn flex-fill py-3"
                  onClick={() => setTradeType('')}
                  style={{
                    background: 'rgba(212, 175, 55, 0.1)',
                    border: '1px solid rgba(212, 175, 55, 0.3)',
                    borderRadius: '16px',
                    color: '#D4AF37',
                    fontWeight: 'bold'
                  }}
                >
                  Cancel
                </button>
                <button
                  className={`btn flex-fill py-3`}
                  onClick={placeOrder}
                  style={{
                    background: tradeType === 'BUY' ? 'linear-gradient(145deg, #00C853, #009624)' : 'linear-gradient(145deg, #FF5252, #D32F2F)',
                    border: 'none',
                    borderRadius: '16px',
                    color: '#fff',
                    fontWeight: 'bold'
                  }}
                >
                  CONFIRM {tradeType}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Trade Details Card */}
        <div style={{
          background: 'rgba(20, 20, 20, 0.95)',
          borderRadius: '24px',
          border: '1px solid rgba(212, 175, 55, 0.2)',
          marginBottom: '20px'
        }}>
          <div className="p-3">
            <h6 className="fw-bold mb-3" style={{ color: '#D4AF37', letterSpacing: '1px' }}>TRADE DETAILS</h6>
            
            <div className="row mb-2">
              <div className="col-6" style={{ color: '#888' }}>Currency Pair</div>
              <div className="col-6 text-end fw-semibold" style={{ color: '#fff' }}>{cur_code?.toUpperCase()}</div>
            </div>
            
            <div className="row mb-2">
              <div className="col-6" style={{ color: '#888' }}>Current Rate</div>
              <div className="col-6 text-end fw-semibold" style={{ color: '#D4AF37' }}>${formatNumber(rate)}</div>
            </div>
            
            <div className="row mb-2">
              <div className="col-6" style={{ color: '#888' }}>Wallet Balance</div>
              <div className="col-6 text-end fw-semibold" style={{ color: '#00C853' }}>${formatNumber(balance)}</div>
            </div>
            
            <div className="row mb-2">
              <div className="col-6" style={{ color: '#888' }}>24H High</div>
              <div className="col-6 text-end fw-semibold" style={{ color: '#FF5252' }}>${formatNumber(high)}</div>
            </div>
            
            <div className="row mb-2">
              <div className="col-6" style={{ color: '#888' }}>24H Low</div>
              <div className="col-6 text-end fw-semibold" style={{ color: '#00C853' }}>${formatNumber(low)}</div>
            </div>
            
            <div className="row">
              <div className="col-6" style={{ color: '#888' }}>Leverage</div>
              <div className="col-6 text-end fw-semibold" style={{ color: '#D4AF37' }}>1:{lev}</div>
            </div>
          </div>
        </div>
      </div>

      <style>
        {`
          .btn-golden {
            background: linear-gradient(145deg, #D4AF37, #B8960C);
            transition: all 0.3s ease;
          }
          .btn-golden:hover {
            transform: translateY(-2px);
            box-shadow: 0 5px 20px rgba(212, 175, 55, 0.3);
          }
          input:focus {
            box-shadow: 0 0 0 2px rgba(212, 175, 55, 0.3) !important;
            outline: none;
            border-color: #D4AF37 !important;
          }
          input[type="number"]::-webkit-inner-spin-button,
          input[type="number"]::-webkit-outer-spin-button {
            opacity: 0.5;
          }
        `}
      </style>
    </div>
  );
};

export default TradeChartScreen;